export const ROUTES = {
  HOME: "/",
  ABOUTUS: "/aboutus",
  CONTACTUS: "/contactus",
  // FREQUENTQUESTIONS: "/frequentquestions",
  PRODUCTS: "/products",
  HOSTING: "/hosting",
  TOURS: "/tours",
  TRANSPORTS: "/transports",
  SHIPS: "/ships",
};
